exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".u4QXrSGqyM3BNUwnDIhwW{text-align:center}.u4QXrSGqyM3BNUwnDIhwW ._3vMsvCcsyGDOGHyAUwWHvX{font-size:26px;font-weight:600;margin:0 0 20px 0}\n", ""]);

// Exports
exports.locals = {
	"GridItem": "u4QXrSGqyM3BNUwnDIhwW",
	"value": "_3vMsvCcsyGDOGHyAUwWHvX"
};